import { FindOperator } from "../FindOperator";
export function And() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }
  return new FindOperator("and", values, true, true);
}